<script>
  //全局路径
  const globalPath = {};
  let path;
  if (process.env.NODE_ENV === "development") {
      // dev
      path = {
        api: "/api/", //主页调用接口地址
      }
  } else {
      // build
      path = {
        api: "http://192.168.0.1/", //主页调用接口地址
      }
  }
  Object.assign(globalPath, path);
  export default {
    globalPath
  };
</script>



// WEBPACK FOOTER //
// src/assets/script/globalPath.vue